import { initSLFPage } from '@bark/bark-core/src/components/start/slf-page-app';
// run
export async function main() {
	initSLFPage();
}

main().then(() => {
	console.log('slf page app start');
});
